// --------------------------------------------- All Imports --------------------------------------------

import gsap from "gsap";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import image1 from "../../assets/images/Rectangle 102.png";
import image2 from "../../assets/images/Rectangle 104.png";
import image3 from "../../assets/images/Rectangle 105.png";
import image4 from "../../assets/images/Rectangle 106.png";
import tringle from "../../assets/images/tringle.png";
import walk from "../../assets/images/walk.png";

// --------------------------------------------- All Imports --------------------------------------------

const HeroSection = () => {
  const navigate =useNavigate();
  // --------------------------------------------- Use Effect for animations (Hero Section) ----------------------------------------------------

  useEffect(() => {
    // ---------------------------------------------------- Rotate image animations ----------------------------------------------------

    gsap.fromTo(
      ".image",
      { opacity: 0, scale: 0, rotation: -160, borderRadius: "100%" },
      {
        opacity: 1,
        scale: 1,
        rotation: 0,
        duration: 2.5,
        ease: "power2.out",
        stagger: 0.3,
        borderRadius: "79px",
        onUpdate: function () {
          const width = window.innerWidth;
          if (width >= 484 && width <= 1280) {
            gsap.set(".image", { borderRadius: "50px" });
          } else if (width < 484) {
            gsap.set(".image", { borderRadius: "23px" });
          }
        },
      }
    );

    // ----------------------------------------------- Zoom-out effect for specific images -----------------------------------------------

    gsap.fromTo(
      ".zoom-out",
      { scale: 0, opacity: 0, filter: "blur(10px)", borderRadius: "100%" },
      {
        scale: 1,
        opacity: 1,
        filter: "blur(0px)",
        duration: 2.5,
        ease: "power2.out",
        borderRadius: "79px",
        onUpdate: function () {
          const width = window.innerWidth;
          if (width >= 484 && width <= 1280) {
            gsap.set(".zoom-out", { borderRadius: "50px" });
          } else if (width < 484) {
            gsap.set(".zoom-out", { borderRadius: "23px" });
          }

        },
      }
    );

    // ------------------------------------------ Zoom-out effect for specific images ------------------------------------------

    gsap.fromTo(
      ".ring-zoom-out",
      { scale: 0, opacity: 0, filter: "blur(50px)" },
      {
        scale: 1,
        opacity: 1,
        filter: "blur(0px)",
        yoyo: true,
        duration: 2.5,
        ease: "power2.out",
      }
    );

    // --------------------------------------- Animation for Image 4 with small height/width to full size + rotationX -------------------------------------------

    gsap.fromTo(
      ".rotate-x",
      {
        rotationX: -180,
        transformOrigin: "center center",
        opacity: 0,
        scale: 0,
        borderRadius: "100%",
      },
      {
        rotationX: 0,
        transformOrigin: "center center",
        opacity: 1,
        duration: 2.5,
        ease: "power2.out",
        scale: 1,
        repeatDelay: 0.8,
        borderRadius: "79px",
        onUpdate: function () {
          const width = window.innerWidth;
          if (width >= 484 && width <= 1280) {
            gsap.set(".rotate-x", { borderRadius: "50px" });
          } else if (width < 484) {
            gsap.set(".rotate-x", { borderRadius: "23px" });
          }
        },
      }
    );

    // --------------------------------------- Animation for text (left to right) ----------------------------------------

    gsap.utils.toArray(".text").forEach((text, index) => {
      gsap.fromTo(
        text,
        {
          opacity: 0,
          x: -200,
        },
        {
          opacity: 1,
          x: 0,
          duration: 2,
          delay: index * 0.5,
          ease: "power2.out",
        }
      );
    });

    // -------------------------------------------------  single Round Animation -------------------------------------------------

    gsap.fromTo(
      ".single-round",
      { scale: 0.3, borderRadius: "0" },
      {
        opacity: 1,
        scale: 1,
        duration: 3,
        ease: "power2.out",
        borderRadius: "50%",
      }
    );

    // ------------------------------------------------- round box animation -------------------------------------------------

    gsap.fromTo(
      ".gradBorder",
      { scale: 0.2, transformOrigin: "center center", borderRadius: "100%" },
      {
        transformOrigin: "center center",

        scale: 1,
        duration: 3,
        ease: "power2.out",
        borderRadius: "50px",
      }
    );

    gsap.to(".play", {
      scale: 1.2,
      duration: 1.5,
      ease: "power1.inOut",
      yoyo: true,
      repeat: -1,
    });
  }, []);

  // ---------------------------------------------------- rolling text button animation ----------------------------------------------------

  const handleMouseEnter = (e) => {
    const button = e.currentTarget;
    const visibleSpan = button.querySelector(".btn1");
    const hiddenSpan = button.querySelector(".btn2");

    gsap.to(visibleSpan, {
      duration: 1,
      y: -100,
      ease: "power2.inOut",
    });
    gsap.to(hiddenSpan, {
      duration: 1.5,
      y: -50,
      ease: "power2.inOut",
      opacity: 1,
    });
  };

  const handleMouseLeave = (e) => {
    const button = e.currentTarget;
    const visibleSpan = button.querySelector(".btn1");
    const hiddenSpan = button.querySelector(".btn2");

    gsap.to(visibleSpan, {
      duration: 0.5,
      y: 0,
      ease: "power2.inOut",
    });
    gsap.to(hiddenSpan, {
      duration: 1,
      y: 0,
      ease: "power2.inOut",
      opacity: 0,
    });
  };


  const handleClick = () => {
    navigate("/aboutus");
  };

  // ---------------------------------------------------- rolling text button animation ----------------------------------------------------

  return (
    <>
      {/* Main Hero Section */}
      <div className="text-white hero-section  mt-3 mb-3 overflow-hidden relative -z-50 flex 850:flex-row xs:flex-col">
        {/* Left Content */}
        <div className="md:w-[55%] w-[100%] max-850:h-[70%] max-md:h-full overflow-hidden">
          <div className="flex flex-col gap-[22px] lg:mt-[78px] md:mt-[67px] xs:mt-[40px] 2xl:ml-[4rem] xl:ml-20 md:ml-8 xs:ml-6">
            <p className="font-raleway font-medium xs:text-[16px] sm:text-[20px] md:text-[24px] lg:text-[30px] xl:text-[32px]">
              Since 2001
            </p>
            <h1 className="font-raleway font-medium xs:text-[18px] sm:text-[24px] lg:text-[32px] 2xl:text-[48px] xl:text-[40px]">
              Delivering Excellence in
            </h1>
            <div className="scroller font-faustina font-semibold 2200:text-[70px] lg:text-[60px] md:text-[45px] xs:text-[32px]">
              <span>
                IT Consulting
                <br />
                Wellness
                <br />
                Care Foundation
                <br />
                Education
                <br />
                Health Care
                <br />
                R & D
                <br />
                Adult Day Care
                <br />
                Product Services
              </span>
            </div>
          </div>

          {/* only md and lg) */}
          <div className="hidden 850:block w-full h-auto overflow-hidden">
            <div className="ring-3 single-round 2xl:top-[51%] 850:top-[45%] 2xl:-left-[14%] Txl:-left-[9%] xl:-left-[12%] lg:-left-[calc(229px+23px)] lg:top-[40%] 850:-left-[33%] md:w-[84%] md:h-[78%] 850:w-[75%] 850:h-[90%] lg:w-[65%] lg:h-[65%] 1150:w-[60%] 1150:h-[60%] 2xl:w-[841px] 2xl:h-[778px] xl:w-[53%] xl:h-[77%]">
              <div className="w-full h-full relative -top-8 font-faustina ">
                <div className="box1 md:w-[180px] md:h-[85px] 850:w-[150px] 850:h-[75px] lg:w-[170px] lg:h-[85px] 1150:w-[180px] 1150:h-[95px] gradBorder uppercase z-10 bg-black rounded-2xl text-white flex flex-col gap-2 items-center justify-center absolute md:top-[3%] 850:top-[6%] lg:top-7 md:left-[40%] xl:left-[35%] 1150:left-[40%] lg:left-[45%] 850:left-[48%]">
                  <div className="absolute inset-0 rounded-2xl border-gradient"></div>
                  <div className="relative flex flex-col gap-1 justify-center items-center z-10">
                    <p className="md:text-[30px] 850:text-[18px] lg:text-[20px] 1150:text-[28px] leading-[33px] font-semibold">
                      200 +
                    </p>
                    <p className="md:text-lg 850:text-[14px] lg:text-[16px] 1150:text-lg leading-[25px]">
                      Client Served
                    </p>
                  </div>
                </div>

                {/* <div className="box2 md:w-[180px] md:h-[85px] lg:w-[180px] lg:h-[95px] gradBorder uppercase z-10 bg-black rounded-2xl text-white flex flex-col gap-2 items-center justify-center absolute md:top-[20%] lg:top-28 md:right-[5%] lg:right-[11.5%]"> */}
                <div className="box2 md:w-[180px] md:h-[85px] 850:w-[150px] 850:h-[75px] lg:w-[170px] lg:h-[85px] 1150:w-[180px] 1150:h-[95px] gradBorder uppercase z-10 bg-black rounded-2xl text-white flex flex-col gap-2 items-center justify-center absolute 850:top-[24%] 850:right-[1%] 950:top-[23%] 950:right-[3%] lg:top-[28%] xl:top-[20%] 2xl:top-[102px] xl:right-[5%] lg:right-[-1%] 2xl:right-[12%]">
                  <div className="absolute inset-0 rounded-2xl border-gradient"></div>
                  <div className="relative flex flex-col gap-1 justify-center items-center z-10">
                    <p className="md:text-[30px] 850:text-[18px] lg:text-[20px] 1150:text-[28px] leading-[33px] font-semibold">
                      50000 +
                    </p>
                    <p className="md:text-lg 850:text-[14px] lg:text-[16px] 1150:text-lg leading-[25px]">
                      PEOPLE HELPED
                    </p>
                  </div>
                </div>

                <div className="box3 md:w-[180px] md:h-[85px] 850:w-[150px] 850:h-[75px] lg:w-[170px] lg:h-[85px] 1150:w-[180px] 1150:h-[95px] gradBorder uppercase z-10 bg-black rounded-2xl text-white flex flex-col gap-2 items-center justify-center absolute md:top-[45%] lg:top-80 md:left-[83%] lg:left-[85%] 850:top-[52%] 950:left-[89%] 850:left-[87%]">
                  <div className="absolute inset-0 rounded-2xl border-gradient"></div>
                  <div className="relative flex flex-col gap-1 justify-center items-center z-10">
                    <p className="md:text-[30px] 850:text-[18px] lg:text-[20px] 1150:text-[28px] xs:text-[0px] leading-[33px] font-semibold">
                      20000 +
                    </p>
                    <p className=" md:text-lg 850:text-[14px] lg:text-[16px] 1150:text-lg leading-[25px]">
                      STUDENT TRAINED
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Image Section */}
        <div className="flex flex-col items-center justify-center lg:w-[55%] 850:w-[60%] xs:w-[100%] xl:gap-10 md:gap-7 xs:gap-4 z-20 relative  px-8 xl:mt-16 1150:mt-20 850:mt-[50px] md:mt-[-150px] sm:mt-[-240px] 550:mt-[-180px] 500:mt-[-170px] 480:mt-[-150px] 370:mt-[-190px] xs:mt-[-190px]">
          {/* Decorative Rings */}
          <div className="hidden 850:block ring-1 ring-zoom-out absolute 850:left-[15%] 850:top-[16%] 850:w-[350px] 900:h-[300px] 900:left-[17%] 900:top-[19%] 900:w-[370px] 850:h-[300px] 950:left-[17%] 950:top-[17%] 950:w-[400px] 950:h-[350px] 1150:left-[18%] 1150:top-[10%] 1150:w-[450px] 1150:h-[370px] xl:left-[12%] xl:top-[12%] xl:w-[525px] xl:h-[420px] 1350:left-[18%] 1350:top-[12%] 1350:w-[545px] 1350:h-[420px] 1450:left-[18%] 1450:top-[12%] 1450:w-[597px] 1450:h-[420px] 2xl:left-[17%] 2xl:top-[10%] 2xl:w-[626px] 2xl:h-[476px] 1600:left-[20%] 1600:top-[10%] 1600:w-[626px] 1600:h-[476px] 1700:left-[26%] 1700:top-[10%] 1700:w-[626px] 1700:h-[476px]"></div>
          <div className="hidden 850:block ring-2 ring-zoom-out absolute 850:left-[60%] 850:top-[15%] 850:w-[482.82px] 850:h-[546.36px] 1024:left-[60%] 1024:top-[9%] 1024:w-[690px] 1024:h-[650px] xl:left-[60%] xl:top-[9%] xl:w-[725px] xl:h-[700px] 1300:left-[65%] 1300:top-[7%] 1300:w-[725px] 1300:h-[750px] 2xl:left-[60%] 2xl:top-[10%] 2xl:w-[725px] 2xl:h-[733px]"></div>
          <div className="block 850:hidden ring-1 ring-zoom-out absolute  xs:left-[20%] xs:top-[21%] xs:w-[230px] xs:h-[150px] 370:left-[25%] 370:top-[21%] 370:w-[250px] 370:h-[170px] 428:left-[25%] 428:top-[16%] 428:w-[280px] 428:h-[200px] 450:left-[25%] 450:top-[14%] 450:w-[310px] 450:h-[230px] 500:left-[25%] 500:top-[19%] 500:w-[300px] 500:h-[270px] 550:left-[25%] 550:top-[17%] 550:w-[320px] 550:h-[280px] 600:left-[27%] 600:top-[17%] 600:w-[350px] 600:h-[300px] sm:left-[27%] sm:top-[17%] sm:w-[380px] sm:h-[320px] 700:left-[30%] 700:top-[17%] 700:w-[380px] 700:h-[320px]"></div>
          <div className="block 850:hidden ring-2 ring-zoom-out absolute xs:left-[65%] xs:top-[10%] xs:w-[620px] xs:h-[380px] 428:left-[65%] 428:top-[10%] 428:w-[600px] 428:h-[440px] 500:left-[65%] 500:top-[10%] 500:w-[600px] 500:h-[470px] 700:left-[65%] 700:top-[10%] 700:w-[580px] 700:h-[470px]"></div>

          <div className="flex justify-center xl:gap-5 1150:gap-7 850:gap-5 sm:gap-8 xs:gap-5 items-end pt-10">
            <div className="image overflow-hidden  xl:w-[56%] xl:h-[260px] 1150:w-[60%] 1150:h-[60%] lg:w-[60%] lg:h-[55%] 850:w-[60%] 850:h-[55%] sm:w-[46%] sm:h-[58%] 500:w-[45%] 500:h-[58%] xs:w-[55%] xs:h-[55%]">
              <img
                src={image2}
                alt="2"
                className="object-cover object-top w-full h-full"
              />
            </div>
            <div className="zoom-out overflow-hidden xs:w-[40%] xs:h-[170px] 370:w-[35%] 370:h-[200px] 500:w-[30%] 500:h-[250px] sm:w-[28%] sm:h-[250px] 850:w-[40%] 850:h-[300px] lg:w-[40%] lg:h-[310px] 1150:w-[46%] 1150:h-[300px] xl:w-[38%] xl:h-[362px]">
              <img
                src={image1}
                alt="1"
                className="object-cover w-full h-full"
              />
            </div>
          </div>
          <div className="flex justify-center xl:gap-5 1150:gap-7 850:gap-5 sm:gap-8 xs:gap-5 pb-10">
            <div className="zoom-out overflow-hidden xs:w-[40%] xs:h-[170px] 370:w-[35%] 370:h-[200px] 500:w-[30%] 500:h-[250px] sm:w-[29%] sm:h-[250px] 850:w-[42%] 850:h-[300px] lg:w-[40%] lg:h-[310px] 1150:w-[44%] 1150:h-[300px] xl:w-[38%] xl:h-[362px]">
              <img
                src={image3}
                alt="3"
                className="object-cover w-full h-full"
              />
            </div>
            <div className="rotate-x overflow-auto xs:w-[55%] xs:h-[55%] xl:w-[56%] xl:h-[260px]  1150:w-[60%] 1150:h-[65%] lg:w-[60%] lg:h-[55%] 850:w-[60%] 850:h-[55%] sm:w-[50%] sm:h-[58%] 500:w-[50%] 500:h-[55%]">
              <img
                src={image4}
                alt="4"
                className="object-cover object-top w-full h-full"
              />
            </div>
          </div>
        </div>

        {/* xs/sm only) */}
        <div className="block 850:hidden w-full h-full overflow-hidden">
          <div className="ring-3 xs:top-[60%] 370:top-[63%] 480:top-[65%] 500:top-[67%] 550:top-[68%] sm:top-[63%] md:top-[60%] 500:left-[-88%] sm:left-[-55%] md:left-[-95%] xs:left-[-72.4%] sm:w-[120%] sm:h-[60%] md:w-[156%] md:h-[57%] 500:w-[163.7%] 500:h-[55.2%] xs:w-[152%] xs:h-[55.2%] 850:top-0 single-round">
            <div className="w-full h-full relative -top-16 font-faustina">
              <div className="box-wrapper 400:w-[150px] xs:w-[130px] 400:h-[75px] 500:top-[16%] 500:left-[60%] 550:top-[15%] 550:left-[60%] md:top-[13.5%] md:left-[66%] sm:top-[11%] xs:top-[15%] absolute sm:left-[50%] xs:left-[53%] z-10">
                <div className="box-content uppercase bg-black rounded-[16px] text-white flex flex-col gap-2 items-center justify-center h-full w-full relative">
                  <div className="flex flex-col gap-1 justify-center items-center z-10">
                    <p className="400:text-[18px] xs:text-[16px] xs:leading-[20px] leading-[33px] font-semibold">
                      200 +
                    </p>
                    <p className="400:text-[14px] xs:text-[12px] leading-[25px]">
                      Client Served
                    </p>
                  </div>
                </div>
              </div>

              {/* ------------------------------- BOX 2 ------------------------------- */}
              <div className="box2 p-[3px] bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] rounded-[16px] 400:w-[150px] xs:w-[130px] 400:h-[75px]  500:top-[30%] 500:left-[80%] sm:top-[27%] sm:left-[78%] md:top-[30%] md:left-[84%] xs:top-[33%] absolute xs:left-[77%] z-10">
                <div className="bg-black rounded-[16px] text-white flex flex-col gap-2 items-center justify-center h-full w-full uppercase">
                  <div className="flex flex-col gap-1 justify-center items-center z-10">
                    <p className="400:text-[18px] xs:text-[16px] xs:leading-[20px] leading-[33px] font-semibold">
                      50000 +
                    </p>
                    <p className="400:text-[14px] xs:text-[12px] leading-[25px]">
                      PEOPLE HELPED
                    </p>
                  </div>
                </div>
              </div>

              {/* ------------------------------- BOX 3 ------------------------------- */}
              <div className="box3 p-[3px] bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] rounded-2xl 400:w-[150px] xs:w-[130px] 400:h-[75px] 500:top-[53%] 500:left-[91%] sm:top-[56%] sm:left-[91%] md:top-[55%] md:left-[94%] xs:top-[55%] absolute xs:left-[87%] z-10">
                <div className="bg-black rounded-2xl text-white flex flex-col gap-2 items-center justify-center h-full w-full uppercase">
                  <div className="flex flex-col gap-1 justify-center items-center z-10">
                    <p className="400:text-[18px] xs:text-[16px] xs:leading-[20px] font-semibold">
                      20000 +
                    </p>
                    <p className="400:text-[14px] xs:text-[12px] leading-[25px]">
                      STUDENT TRAINED
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* "Our Success Speaks For Itself" Section */}
      <div className="flex md:flex-row flex-col w-full justify-center items-center text-[#EEEEEE] font-faustina lg:gap-[78px] md:gap-[48px] xs:gap-[35px] z-10 relative pt-[72px] pb-[40px]">
        <p className="font-semibold 1500:text-[60px] lg:text-[clamp(50px,4.8vw,80px)] 428:text-[clamp(30px,4.7vw,50px)] xs:text-[24px]  xs:leading-none md:leading-[80px] lg:leading-[100px]">
          Our Success Speaks For Itself
        </p>
        <a
          href="https://youtu.be/VaGsymiKZLg?si=j-fBd0hYEBUqw_Yj"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="flex gap-8 items-center cursor-pointer">
            <div className="play lg:w-[83px] lg:h-[83px] md:w-[60px] md:h-[60px] xs:w-[50px] xs:h-[50px] rounded-full flex justify-center items-center bg-gradient-to-r from-[rgb(31,162,255)] via-[rgb(18,216,250)] to-[rgb(166,255,203)]">
              <img
                src={tringle}
                alt="TriangleImage"
                className="lg:max-w-full lg:h-auto md:w-[30px] md:h-[30px] xs:w-[25px] xs:h-[25px]"
              />
            </div>
            <p className="font-normal xs:text-[clamp(20px,3.4vw,32px)]  lg:text-[32px] xs:leading-none md:leading-[80px] lg:leading-[100px]">
              PLAY NOW
            </p>
          </div>
        </a>
      </div>

      {/* "A Walk Through Us" Section */}
      <div className="w-full h-full flex justify-center items-center">
        {/* <div className="w-full flex justify-center items-center"> */}
        <div className="flex flex-col-reverse md:flex-row items-center justify-center 1500:ml-[30px] lg:ml-[60px] md:ml-[20px] xs:ml-[16px] md:mr-[20px] xs:mr-[16px] lg:gap-[50px] md:gap-[30px] xs:gap-[36px]">
          {/* Text Content */}
          <div className="lg:w-[60%] md:w-[50%] xs:w-full flex flex-col justify-center items-center md:items-start text-center md:text-left gap-[40px]">
            <p className=" hidden md:block bg-gradient-to-r from-[#1FA2FF] via-cyan-300 to-[#A6FFCB] text-transparent bg-clip-text font-semibold lg:text-[56px] xs:text-[clamp(40px,5.8vw,56px)] font-faustina">
              A Walk Through Us
            </p>
            <div className="flex flex-col md:items-start xs:items-center lg:gap-[20px] xs:gap-[32px] text-white text-justify font-faustina font-normal 1920:text-[24px] lg:text-[20px] xs:text-[clamp(16px,1.9vw,20px)] leading-[35px]">
              <p>
                Founded in 2001 and proudly expanding our footprint in India since 2021, Param Consulting Services Inc. has been driven by a simple yet powerful vision: to harness innovative technology that transforms lives and accelerates growth. As a trusted IT solutions provider and technology consulting company, we deliver secure, scalable, and cutting-edge solutions across the IT & consulting, education, healthcare, and social development sectors.
              </p>
              <p>
                We empower businesses and communities by developing digital
                transformation platforms, automating workflows to boost
                operational efficiency, and delivering industry-aligned
                upskilling and professional training programs tailored for
                students and working professionals. Our commitment also extends
                to supporting healthcare initiatives that enhance patient care
                and promote healthier communities.
              </p>

              <div className="flex justify-start items-start w-full">
                <div className="flex justify-center items-center w-[155px] md:w-[170px] lg:w-[200px] text-center h-[62px]  bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] rounded-[14px] bg-transparent p-0.5">
                  <Link
                    className="button-main bg-black uppercase w-full h-full rounded-[14px] font-poppins font-medium xs:text-[18px] lg:text-[20px] diagonal text-center relative py-[16px] px-[52px]"
                    onMouseEnter={handleMouseEnter}
                    onClick={handleClick}
                    onMouseLeave={handleMouseLeave}
                    to="/aboutus"
                  >
                    <span className="btn1 absolute transition-all top-[1px] left-0 w-full h-full flex justify-center items-center text-white">
                      Learn more
                    </span>
                    <span className="btn2 absolute transition-all opacity-0 top-[52px] left-0 w-full h-full flex justify-center items-center text-white">
                      Learn more
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          {/* Image Content */}
          <div className="md:w-[40%] xs:w-[80%] flex justify-center items-center">
            <img src={walk} alt="walk through" className=" object-contain" />
          </div>
          {/* Mobile Title */}
          <p className="block md:hidden bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] text-transparent bg-clip-text font-semibold text-[40px] text-center font-faustina">
            A Walk Through Us
          </p>
        </div>
        {/* </div> */}
      </div>
    </>
  );
};

export default HeroSection;
